import { render, staticRenderFns } from "./CheckoutTags.vue?vue&type=template&id=081ca8df&scoped=true&"
import script from "./CheckoutTags.vue?vue&type=script&lang=js&"
export * from "./CheckoutTags.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutTags.vue?vue&type=style&index=0&id=081ca8df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081ca8df",
  null
  
)

export default component.exports